const initialBrowserOnline =
  typeof navigator !== "undefined" ? navigator.onLine : true

const state = {
  browserOnline: initialBrowserOnline,
  isSlowConnection: false
}

const getters = {
  shouldShowNetworkIssue(state) {
    return !state.browserOnline || state.isSlowConnection
  },
  isBrowserOffline(state) {
    return !state.browserOnline
  },
  isSlowConnection(state) {
    return state.isSlowConnection
  },
  networkIssueKind(state) {
    if (!state.browserOnline) {
      return "offline"
    }
    if (state.isSlowConnection) {
      return "slow"
    }
    return null
  }
}

const mutations = {
  SET_BROWSER_ONLINE(state, online) {
    if (state.browserOnline === online) {
      return
    }
    state.browserOnline = online
    if (!online) {
      state.isSlowConnection = false
    }
  },
  SET_SLOW_CONNECTION(state, isSlow) {
    if (state.isSlowConnection === isSlow) {
      return
    }
    state.isSlowConnection = isSlow
  },
  RESET(state) {
    state.browserOnline =
      typeof navigator !== "undefined" ? navigator.onLine : true
    state.isSlowConnection = false
  }
}

const actions = {
  setBrowserOnline({ commit }, online) {
    commit("SET_BROWSER_ONLINE", online)
  },
  setSlowConnection({ commit, state }, isSlow) {
    if (!state.browserOnline && isSlow) {
      return
    }
    if (state.isSlowConnection === isSlow) {
      return
    }
    commit("SET_SLOW_CONNECTION", isSlow)
  },
  /** Re-read navigator.onLine (DevTools offline toggle often skips the `online` event). */
  syncBrowserOnlineFromNavigator({ commit, state }) {
    if (typeof navigator === "undefined") {
      return
    }
    const online = navigator.onLine
    if (state.browserOnline !== online) {
      commit("SET_BROWSER_ONLINE", online)
    }
    if (!online && state.isSlowConnection) {
      commit("SET_SLOW_CONNECTION", false)
    }
  },
  reset({ commit }) {
    commit("RESET")
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
